import moment from 'moment';
const app = {};

app.comma = (val, round = 2) => {
    const options = {
        minimumFractionDigits: round,
        maximumFractionDigits: round
    }
    return Number(val).toLocaleString('en', options);
}

app.str2number = (val) => {
    val = val + '';
    return parseFloat(val.replace(/[^\d\.\-]/g, ""));
}

app.getOnlyAlphabets = (string) => {
    return string.replace(/[^a-zA-Z ]/g, "")
}


app.round = (val, decimals) => {
    var y = app.str2number(val);
    y = (Math.abs(y) > 0.000000001) ? y : 0;
    if (decimals === 0) {
        decimals = 0;
    } else {
        decimals = (decimals) ? decimals : 2;
    }
    var d = decimals * 1 + 8;
    d = (d > 12) ? 12 : d;
    y = Number(Math.round((y).toFixed(d) + 'e' + d) + 'e-' + d).toFixed(d);
    res = Number(Math.round((y + "").replace(/[^0-9.-]/g, '') + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    return app.str2number(res);
};

app.isMail = (mail) => {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

    if (!mail.match(emailReg)) {
        return false
    }
    else return true;
}

app.formatDate = (date, format = 'DD-MMM-YYYY', origin = 'YYYY-MM-DD') => {
    var m = moment(date, origin);
    return (m.isValid()) ? moment(date, origin)
        .format(format) : '';
}

app.objectLength = (obj) => {
    return Object.keys(obj).length
}

app.findIndex = (array, [key, value]) => {
    return array.findIndex(x => x[key] == value);
}

app.lastUpdateAt = (updated_at) => {
    let now = new Date().getTime();
    let updated = new Date(updated_at).getTime();
    let different = now - updated;
    let days = Math.floor(different / 1000 / 60 / (60 * 24));
    let hours = Math.floor(different / 1000 / 60 / 60);
    let minutes = Math.floor(different / 1000 / 60);
    if (days > 0) {
        return days + 'd'
    }
    else if (hours > 0) {
        return hours + "h"
    }
    else if (minutes > 0) {
        return minutes + "m"
    }
    else {
        return "a few time"
    }
}

app.isoDate = (date = null) => {
    var d = (date) ? new Date(date) : new Date;
    var isoDate = new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString();
    return isoDate;
}

app.bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

app.confirm = (text, button = 'YES', bodyMessage = '') => {
    return new Promise(async (resolve, reject) => {
        let res = await Swal.fire({
            title: text,
            html: bodyMessage,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#0aa699",
            cancelButtonColor: "#d33",
            confirmButtonText: button
        })
        if (res.value) {
            resolve(true);
        }
    })
}

app.lower = (text) => {
    return (text) ? text.toLowerCase() : '';
}

app.capitalize = (text) => {
    return text && text[0].toUpperCase() + text.slice(1);
}

app.upper = (text) => {
    return text.toUpperCase();
}
app.date = (date, ifNullText = '-') => {
    if (date) {
        return moment(date).utc().format('DD MMM, YYYY');
    }
    else {
        return ifNullText;
    }
}


app.tzDate = (date, timeZone) => {
  if (!date) return '-'

  // Convert MySQL "YYYY-MM-DD HH:mm:ss" → ISO UTC
  const iso = date.replace(' ', 'T') + 'Z'
  const parsedDate = new Date(iso)

  if (isNaN(parsedDate)) return '-'

  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(parsedDate)

  const map = Object.fromEntries(parts.map(p => [p.type, p.value]))

  return `${map.day} ${map.month}, ${map.year}`
}

/**
 * Format the ID of a shirt order to make it easier to distinguish between:
 * - sample and real customer shirt,
 * - male, female and lady shirt
 *
 * It will add the following prefixes before the actual ID of the shirt:
 * - S before a sample shirt
 * - W before the old female shirt
 * - L before the lady shirt
 * - no prefix for the male shirt
 *
 * @param shirt
 * @returns {string}
 */
app.formatShirtId = (shirt) => {
    let formattedId = '';
    if (shirt.sample_shirt === 1) {
        formattedId += 'S ';
    }
    if (shirt.type === 'female') {
        formattedId += 'W ';
    } else if (shirt.type === 'lady') {
        formattedId += 'L ';
    }
    formattedId += shirt.id;
    return formattedId;
}

/**
 * This function was created to allow user authorization check when opening a PDF in a new tab.
 * If we just open the PDF in a new tab (for ex: using click and target=_blank), the generated request will
 * not contain the `Authorization: Bearer XXXX` header, and the system will act as the current user doesn't have
 * the permission to do the current action.
 *
 * This method will:
 * - send a request with the correct `Authorization: Bearer XXXX`
 * - save the response as a blob
 * - create an object URL for that blob response
 * - then display the PDF in the new tab.
 *
 * @param url
 * @returns {Promise<void>}
 */
app.openPDFInNewWindow = async (url) => {
    try {
        let response = await axios({
            url: url,
            method: 'GET',
            data: {},
            responseType: 'blob', // important
        })
        if (response) {
            let file = new Blob([response.data], {
                type: 'application/pdf'
            });
            let url = URL.createObjectURL(file);
            Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
        }
    } catch (error) {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        if (error.response.status === 403) {
            toastr.error('Not authorized, please ensure that you have the required permissions.');
        } else if (error.response.status === 422) {
            toastr.error(json.message);
        } else {
            toastr.error('There was some errors, please correct and try again, or contact the admins');
        }
    }
}

export default app;
